import { useEffect, useRef, useState } from "react";
import { getFacilityData } from "../../apis/AdminDashboard/users";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import SideBar from "../../components/AdminDashboard/SideBar";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import {  getUserInfo } from "../../apis/General/users";
import Skeleton from "react-loading-skeleton";
import { toast } from "react-toastify";

function UploadValidation() {
  const mediaRef = useRef(null);
  const auth = useSelector((state) => state.auth);
  console.log("userID",auth?.userInfo?.id,)
  const token = auth?.token;
  const { id } = useParams();
  console.log("validated-project-id", id);

  // ── UI state ────────────────────────────────────────────────────────────
  const [showForm, setShowForm] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uplaodLoading, setUploadLoading] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [additionalComment, setAdditionalComment] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");

  // ── three independent document slots ────────────────────────────────────
  const [documents, setDocuments] = useState({
    justificationStatement: "",
    quantificationMethodology: "",
    projectDesignDocument: "",
  });

  // ── query ───────────────────────────────────────────────────────────────
  const { data: validatedProjectData = [], isPending: facilityLoading } =
    useQuery({
      queryKey: ["facilities-kyc", id, token],
      queryFn: ({ signal }) => getFacilityData({ id, token, signal }),
      enabled: Boolean(id) && Boolean(token),
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
      select: (res) =>
        (res?.message?.facilities ?? []).filter(
          (facility) => facility?.id === id,
        ),
    });
  console.log("validatedProjectData", validatedProjectData);

  // ── map the returned object into the render shape ───────────────────────
  const selectedKyc = validatedProjectData[0];
  const isGreen = selectedKyc?.facilityCategory === "green";
const getInfo = async () => {
    try {
    const response = await getUserInfo('djDxEqJhTBcyMRudE4irdZB', auth?.token);
        console.log("userInfo", response);
    }
    catch (error) {
        console.error("Error fetching user info:", error);
    }}
  // hydrate local state once data arrives
  useEffect(() => {
    if (!selectedKyc) return;
    setDocuments({
      justificationStatement: selectedKyc?.justificationStatement ?? "",
      quantificationMethodology: selectedKyc?.quantificationMethodology ?? "",
      projectDesignDocument: selectedKyc?.projectDesignDocument ?? "",
    });
    setFirstName(selectedKyc?.firstName ?? "");
    setLastName(selectedKyc?.lastName ?? "");
    setEmail(selectedKyc?.email ?? "");
    setCompanyName(selectedKyc?.companyName ?? "");
    getInfo();
  }, [selectedKyc]);

  // ── helpers ─────────────────────────────────────────────────────────────
  const handleUpload = (field, e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploadLoading(true);
    // TODO: plug in your real upload → then:
    // const url = await uploadFile(file, token);
    // setDocuments((d) => ({ ...d, [field]: url }));
    setUploadLoading(false);
    e.target.value = "";
  };

  const handleDocumentDownload = (url, fallbackName) => {
    const documentUrlValue = Array.isArray(url)
      ? url.find((value) => typeof value === "string" && value.trim())
      : url;
    if (typeof documentUrlValue !== "string" || !documentUrlValue.trim()) {
      toast.error("Document URL is not available.");
      return;
    }

    try {
      const rawUrl = documentUrlValue.trim();
      const hasScheme = /^[a-z][a-z\d+.-]*:\/\//i.test(rawUrl);
      if (hasScheme && !/^https?:\/\//i.test(rawUrl)) {
        throw new Error("Unsupported document URL protocol");
      }

      const normalizedDocumentUrl = /^http:\/\//i.test(rawUrl)
        ? rawUrl.replace(/^http:\/\//i, "https://")
        : /^https:\/\//i.test(rawUrl)
          ? rawUrl
          : `https://${rawUrl.replace(/^\/+/, "")}`;
      const documentUrl = new URL(normalizedDocumentUrl);

      const link = document.createElement("a");
      link.href = documentUrl.toString();
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.download = fallbackName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Invalid document download URL:", error);
      toast.error("The document URL is invalid.");
    }
  };

  const handleUpdateKyc = () => setModalOpen(true);

  const handleValidate = (_facility) => {
    setLoading(true);
    // TODO: your real validation call
    setLoading(false);
    setModalOpen(false);
  };

  const handleCommentUpload = (e) => {
    e.preventDefault();
    // TODO
  };

  const handleModalClose = () => setModalOpen(false);

if (facilityLoading) {
  return (
    <div className="thirdparty_validation">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="main">
        {/* <Search /> */}

        {/* Tabs skeleton */}
        <div
          className="tab_label_container"
          style={{ display: "flex", gap: "24px", padding: "16px 0" }}
        >
          {[1, 2, 3].map((i) => (
            <Skeleton
              key={i}
              width={180}
              height={40}
              borderRadius={8}
            />
          ))}
        </div>

        <div className="validation-table">
          {/* Sub-filter buttons skeleton */}
          <div className="validation-table__header">
            <div className="flex gap-3">
              {[1, 2, 3].map((i) => (
                <Skeleton
                  key={i}
                  width={140}
                  height={44}
                  borderRadius={10}
                  style={{ marginBottom: "8px" }}
                />
              ))}
            </div>
          </div>

          {/* Repeated validation card skeletons */}
          {[1, 2, 3].map((card) => (
            <div
              key={card}
              className="validation_card"
              style={{ marginBottom: "24px" }}
            >
              {/* Card title */}
              <div className="title_group flex justify-between">
                <Skeleton
                  width={420}
                  height={24}
                  borderRadius={8}
                  style={{ marginBottom: "16px" }}
                />
                <Skeleton
                  width={32}
                  height={32}
                  circle
                  style={{ marginBottom: "16px" }}
                />
              </div>

              <div
                className="card_divider"
                style={{
                  height: "1px",
                  background: "#EAECF0",
                  marginBottom: "20px",
                }}
              ></div>

              {/* Grid of field labels + values */}
              <div className="validation_grid">
                {[1, 2, 3, 4].map((field) => (
                  <div key={field}>
                    <Skeleton
                      width={"60%"}
                      height={16}
                      borderRadius={6}
                      style={{ marginBottom: "8px" }}
                    />
                    <Skeleton
                      width={"90%"}
                      height={20}
                      borderRadius={6}
                      style={{ marginBottom: "8px" }}
                    />
                  </div>
                ))}

                {/* Buttons row (Upload document + Validate) */}
                <div className="flex gap-5" style={{ marginTop: "12px" }}>
                  <Skeleton
                    width={140}
                    height={20}
                    borderRadius={6}
                  />
                  <Skeleton
                    width={145}
                    height={45}
                    borderRadius={10}
                  />
                </div>
              </div>

              {/* Date of validation row */}
              <div className="log" style={{ marginTop: "20px" }}>
                <Skeleton
                  width={"25%"}
                  height={18}
                  borderRadius={6}
                  style={{ marginBottom: "8px" }}
                />
                <Skeleton
                  width={"55%"}
                  height={18}
                  borderRadius={6}
                  style={{ marginBottom: "8px" }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// const { data: userInfo } = useQuery({
//   queryKey: ["user-info", id, token],
//   queryFn: ({ signal }) => getUserInfo(id, token, signal),
//   enabled: Boolean(id) && Boolean(token),
// });
// console.log("userInfo", userInfo);

  return (
    <div className="thirdparty_validation">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="max-w-[1178px] w-[999px]  mx-auto bg-[#FAFAFA] rounded-2xl overflow-hidden ">
        <div className="main p-6 space-y-6 ">
          <button
            className=" items-center  text-gray-600 hover:text-gray-900"
            onClick={() => window.history.back()}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 12H5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M12 19L5 12L12 5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              First name
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              readOnly
            />
          </div>
          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Last name
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              readOnly
            />
          </div>
          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Email
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              readOnly
            />
          </div>
          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Company name
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              readOnly
            />
          </div>

          <div className="flex items-center space-x-4">
            <label className="block text-[14px] mt-8 font-[400] text-[#101828] w-[235px] flex-shrink-0 pt-2">
              {" "}
              {isGreen ? "Green project name" : "Facility name"}
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={
                isGreen
                  ? selectedKyc?.greenProjectName ?? ""
                  : selectedKyc?.facilityName ?? ""
              }
              readOnly
            />
          </div>

          <div className="flex items-start space-x-4">
            <label className="block text-[14px] mt-8 font-[400] text-[#101828] w-[235px] flex-shrink-0 pt-2">
              {" "}
              {isGreen ? "Green project description" : "Facility description"}
            </label>
            <textarea
              rows="4"
              className="flex-1 h-[116px] w-[528px] text-[16px]   px-3 py-2 border border-gray-300  bg-gray-50 rounded-2xl text-[#101828] "
              value={
                isGreen
                  ? selectedKyc?.greenProjectDescription ?? ""
                  : selectedKyc?.facilityDescription ?? ""
              }
              readOnly
            />
          </div>

          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              {isGreen ? "Green project location" : "Facility location"}
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={
                isGreen
                  ? selectedKyc?.greenProjectLocation ?? ""
                  : selectedKyc?.facilityLocation ?? ""
              }
              readOnly
            />
          </div>

          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              {isGreen ? "Green project start date" : "Facility start date"}
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] text-[16px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={
                isGreen
                  ? selectedKyc?.greenProjectStartDate ?? ""
                  : selectedKyc?.facilityStartDate ?? ""
              }
              readOnly
            />
          </div>

          {selectedKyc?.facilityCategory !== "carbon-monitoring" && (
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
                {" "}
                {isGreen ? "Renewable energy" : "Project fuel source"}
              </label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={
                  isGreen
                    ? selectedKyc?.renewableEnergySolutions ?? ""
                    : selectedKyc?.projectFuelSource ??
                      selectedKyc?.generatorFuelType ??
                      selectedKyc?.nonRenewableEnergySource ??
                      ""
                }
                readOnly
              />
            </div>
          )}

          {selectedKyc?.facilityCategory !== "carbon-monitoring" && (
            <div className="flex items-start space-x-4">
              <label className="block text-[14px] font-[400] mt-8 text-[#101828] w-[235px] flex-shrink-0 pt-2">
                Baseline scenario
              </label>
              <textarea
                rows="4"
                className="flex-1 h-[116px] text-[16px] px-3 py-2 border border-gray-300  bg-gray-50 rounded-2xl text-[#101828] "
                value={selectedKyc?.baseLineScenario ?? ""}
                readOnly
              />
            </div>
          )}

          {selectedKyc?.facilityCategory !== "carbon-monitoring" && (
            <div className="flex items-center space-x-4">
              <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
                {isGreen
                  ? "Energy source in baseline scenario"
                  : "Fuel source in baseline scenario"}
              </label>
              <input
                type="text"
                className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
                value={selectedKyc?.baseLineEnergySource ?? ""}
                readOnly
              />
            </div>
          )}
          {selectedKyc?.facilityCategory !== "carbon-monitoring" && (
            <div className="flex items-start space-x-4">
              <label className="block text-[14px] font-[400] mt-8 text-[#101828] w-[235px] flex-shrink-0 pt-2">
                Additional information relevant to the project
              </label>
              <textarea
                rows="4"
                className="flex-1 h-[116px] text-[16px]  px-3 py-2 border border-gray-300  bg-gray-50 rounded-2xl text-[#101828] "
                value={selectedKyc?.additionalInfomation ?? ""}
                readOnly
              />
            </div>
          )}

          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Facility Capacity
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={selectedKyc?.facilityCapacity ?? ""}
              readOnly
            />
          </div>

          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Facility category
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value={selectedKyc?.facilityCategory ?? ""}
              readOnly
            />
          </div>

          <div className="flex items-center space-x-4">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Double counting and participation under other GHG programs
            </label>
            <input
              type="text"
              className="flex-1 w-[528px] h-[59px] px-3 py-2 text-[16px] border border-gray-300 rounded-2xl text-[#101828]  bg-[#FAFAFA] "
              value="NO"
              readOnly
            />
          </div>

          {/* ── 1. Justification statement ─────────────── */}
          <div className="flex  space-y-2">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Proof of fuel source in baseline scenario
            </label>

            <div className="w-[900px] h-[59px] px-3 py-2 border border-gray-300 rounded-2xl text-[#101828] bg-[#FAFAFA]">
              <label className="">
                <div
                  className="document input flex items-center justify-between"
                >
                  <div className="text-[14px] text-[#667185] justify-center flex items-center py-2">
                    {uplaodLoading
                      ? "Loading..."
                      : documents.justificationStatement?.length > 0
                      ? "Document uploaded"
                      : "Choose file to upload"}k
                  </div>
                  {documents.justificationStatement?.length > 0 ? (
                    <button
                      type="button"
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleDocumentDownload(
                          documents.justificationStatement,
                          "justificationStatement",
                        );
                      }}
                      aria-label="Download justification statement"
                    >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.5 1.5C6.70435 1.5 5.94129 1.81607 5.37868 2.37868C4.81607 2.94129 4.5 3.70435 4.5 4.5V19.5C4.5 20.2956 4.81607 21.0587 5.37868 21.6213C5.94129 22.1839 6.70435 22.5 7.5 22.5H16.5C17.2956 22.5 18.0587 22.1839 18.6213 21.6213C19.1839 21.0587 19.5 20.2956 19.5 19.5V8.121C19.4995 7.52446 19.2621 6.95255 18.84 6.531L14.4705 2.1585C14.2615 1.9496 14.0133 1.78393 13.7403 1.67094C13.4672 1.55795 13.1745 1.49987 12.879 1.5H7.5ZM6 4.5C6 4.10218 6.15804 3.72064 6.43934 3.43934C6.72064 3.15804 7.10218 3 7.5 3H12V6.75C12 7.34674 12.2371 7.91903 12.659 8.34099C13.081 8.76295 13.6533 9 14.25 9H18V19.5C18 19.8978 17.842 20.2794 17.5607 20.5607C17.2794 20.842 16.8978 21 16.5 21H7.5C7.10218 21 6.72064 20.842 6.43934 20.5607C6.15804 20.2794 6 19.8978 6 19.5V4.5ZM17.6895 7.5H14.25C14.0511 7.5 13.8603 7.42098 13.7197 7.28033C13.579 7.13968 13.5 6.94891 13.5 6.75V3.3105L17.6895 7.5Z"
                        fill="#667185"
                      />
                    </svg>
                    </button>
                  ) : (
                    <span />
                  )}
                </div>
                {documents.justificationStatement === "" && (
                  <input
                    type="file"
                    multiple
                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    hidden
                    onChange={(e) => handleUpload("justificationStatement", e)}
                    ref={mediaRef}
                  />
                )}
              </label>
            </div>
          </div>

          {/* ── 2. Quantification Methodology ───────────────────────────── */}
          <div className="flex  space-y-2">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Quantification Methodology
            </label>

            <div className="w-[900px] h-[59px] px-3 py-2 border border-gray-300 rounded-2xl text-[#101828] bg-[#FAFAFA]">
              <label className="">
                <div
                  className="document input flex items-center justify-between"
                >
                  <div className="text-[14px] text-[#667185] justify-center flex items-center py-2">
                    {uplaodLoading
                      ? "Loading..."
                      : documents.quantificationMethodology?.length > 0
                      ? "Document uploaded"
                      : "Choose file to upload"}
                  </div>
                  {documents.quantificationMethodology?.length > 0 ? (
                    <button
                      type="button"
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleDocumentDownload(
                          documents.quantificationMethodology,
                          "quantification-methodology",
                        );
                      }}
                      aria-label="Download quantification methodology"
                    >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.5 1.5C6.70435 1.5 5.94129 1.81607 5.37868 2.37868C4.81607 2.94129 4.5 3.70435 4.5 4.5V19.5C4.5 20.2956 4.81607 21.0587 5.37868 21.6213C5.94129 22.1839 6.70435 22.5 7.5 22.5H16.5C17.2956 22.5 18.0587 22.1839 18.6213 21.6213C19.1839 21.0587 19.5 20.2956 19.5 19.5V8.121C19.4995 7.52446 19.2621 6.95255 18.84 6.531L14.4705 2.1585C14.2615 1.9496 14.0133 1.78393 13.7403 1.67094C13.4672 1.55795 13.1745 1.49987 12.879 1.5H7.5ZM6 4.5C6 4.10218 6.15804 3.72064 6.43934 3.43934C6.72064 3.15804 7.10218 3 7.5 3H12V6.75C12 7.34674 12.2371 7.91903 12.659 8.34099C13.081 8.76295 13.6533 9 14.25 9H18V19.5C18 19.8978 17.842 20.2794 17.5607 20.5607C17.2794 20.842 16.8978 21 16.5 21H7.5C7.10218 21 6.72064 20.842 6.43934 20.5607C6.15804 20.2794 6 19.8978 6 19.5V4.5ZM17.6895 7.5H14.25C14.0511 7.5 13.8603 7.42098 13.7197 7.28033C13.579 7.13968 13.5 6.94891 13.5 6.75V3.3105L17.6895 7.5Z"
                        fill="#667185"
                      />
                    </svg>
                    </button>
                  ) : (
                    <span />
                  )}
                </div>
                {documents.quantificationMethodology === "" && (
                  <input
                    type="file"
                    multiple
                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    hidden
                    onChange={(e) =>
                      handleUpload("quantificationMethodology", e)
                    }
                    ref={mediaRef}
                  />
                )}
              </label>
            </div>
          </div>

          {/* ── 3. Project Design Document ──────────────────────────────── */}
          <div className="flex  space-y-2">
            <label className="block text-[14px] font-[400] text-[#101828] w-[235px] flex-shrink-0">
              Project Design Document
            </label>

            <div className="w-[900px] h-[59px] px-3 py-2 border border-gray-300 rounded-2xl text-[#101828] bg-[#FAFAFA]">
              <label className="">
                <div
                  className="document input flex items-center justify-between"
                >
                  <div className="text-[14px] text-[#667185] justify-center flex items-center py-2">
                    {uplaodLoading
                      ? "Loading..."
                      : documents.projectDesignDocument?.length > 0
                      ? "Document uploaded"
                      : "Choose file to upload"}
                  </div>
                  {documents.projectDesignDocument?.length > 0 ? (
                    <button
                      type="button"
                      onClick={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleDocumentDownload(
                          documents.projectDesignDocument,
                          "project-design-document",
                        );
                      }}
                      aria-label="Download project design document"
                    >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.5 1.5C6.70435 1.5 5.94129 1.81607 5.37868 2.37868C4.81607 2.94129 4.5 3.70435 4.5 4.5V19.5C4.5 20.2956 4.81607 21.0587 5.37868 21.6213C5.94129 22.1839 6.70435 22.5 7.5 22.5H16.5C17.2956 22.5 18.0587 22.1839 18.6213 21.6213C19.1839 21.0587 19.5 20.2956 19.5 19.5V8.121C19.4995 7.52446 19.2621 6.95255 18.84 6.531L14.4705 2.1585C14.2615 1.9496 14.0133 1.78393 13.7403 1.67094C13.4672 1.55795 13.1745 1.49987 12.879 1.5H7.5ZM6 4.5C6 4.10218 6.15804 3.72064 6.43934 3.43934C6.72064 3.15804 7.10218 3 7.5 3H12V6.75C12 7.34674 12.2371 7.91903 12.659 8.34099C13.081 8.76295 13.6533 9 14.25 9H18V19.5C18 19.8978 17.842 20.2794 17.5607 20.5607C17.2794 20.842 16.8978 21 16.5 21H7.5C7.10218 21 6.72064 20.842 6.43934 20.5607C6.15804 20.2794 6 19.8978 6 19.5V4.5ZM17.6895 7.5H14.25C14.0511 7.5 13.8603 7.42098 13.7197 7.28033C13.579 7.13968 13.5 6.94891 13.5 6.75V3.3105L17.6895 7.5Z"
                        fill="#667185"
                      />
                    </svg>
                    </button>
                  ) : (
                    <span />
                  )}
                </div>
                {documents.projectDesignDocument === "" && (
                  <input
                    type="file"
                    multiple
                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    hidden
                    onChange={(e) => handleUpload("projectDesignDocument", e)}
                    ref={mediaRef}
                  />
                )}
              </label>
            </div>
          </div>

          <div className="pt-6 flex justify-end space-x-4 max-w-[400px] ml-auto">
            <button
              className="reject-button flex-1 h-[52px] text-[16px] border border-gradient-to-br from-[#038B47] to-[#00AED9] bg-gray-200 text-[#006633] rounded-2xl hover:bg-gray-300 font-medium transition-colors"
              onClick={() => {
                setShowDropdown(true);
              }}
            >
              Leave Comment
            </button>
            <button
              className="flex h-[45px] w-[145px] flex-none items-center justify-center gap-3 rounded-lg px-4 py-2 text-[16px] font-semibold leading-6 text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
              style={{
                background:
                  "linear-gradient(127.56deg, #038B47 0%, #00AED9 100%)",
              }}
              onClick={() => {
                handleUpdateKyc();
              }}
              disabled={
                facilityLoading ||
                !documents.justificationStatement ||
                !documents.quantificationMethodology ||
                !documents.projectDesignDocument
              }
            >
              {facilityLoading ? "Loading..." : "Validate"}
            </button>
          </div>
        </div>

        {showDropdown && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center mx-auto  justify-center z-50"
            onClick={() => setShowDropdown(false)}
          >
            <div
              className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50"
              onClick={() => setShowDropdown(false)}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                className="relative bg-white w-[579px] max-w-[90%] h-[612px] rounded-3xl p-8 flex flex-col shadow-lg"
              >
                <div className="flex items-center gap-2 mb-6">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.9965 7.00065H3.82651L8.70651 2.12065C9.09651 1.73065 9.09651 1.09065 8.70651 0.700647C8.61399 0.607943 8.5041 0.534396 8.38313 0.484214C8.26216 0.434033 8.13248 0.408203 8.00151 0.408203C7.87054 0.408203 7.74086 0.434033 7.61988 0.484214C7.49891 0.534396 7.38902 0.607943 7.29651 0.700647L0.706507 7.29065C0.613803 7.38316 0.540256 7.49305 0.490074 7.61402C0.439893 7.735 0.414063 7.86468 0.414062 7.99565C0.414063 8.12662 0.439893 8.2563 0.490074 8.37727C0.540256 8.49824 0.613803 8.60813 0.706507 8.70065L7.29651 15.2906C7.38909 15.3832 7.499 15.4567 7.61996 15.5068C7.74093 15.5569 7.87058 15.5827 8.00151 15.5827C8.13244 15.5827 8.26209 15.5569 8.38305 15.5068C8.50401 15.4567 8.61392 15.3832 8.70651 15.2906C8.79909 15.1981 8.87253 15.0882 8.92263 14.9672C8.97274 14.8462 8.99853 14.7166 8.99853 14.5856C8.99853 14.4547 8.97274 14.3251 8.92263 14.2041C8.87253 14.0831 8.79909 13.9732 8.70651 13.8806L3.82651 9.00065H14.9965C15.5465 9.00065 15.9965 8.55065 15.9965 8.00065C15.9965 7.45065 15.5465 7.00065 14.9965 7.00065Z"
                      fill="black"
                    />
                  </svg>{" "}
                  Back
                  <h2 className="text-[#101828] font-medium text-2xl mx-auto">
                    Leave Comment
                  </h2>
                </div>
                <form onSubmit={handleCommentUpload}>
                  <div className="flex flex-col gap-3 mb-6">
                    <label className="text-[#101828] font-semibold text-[16px]">
                      Reason for comment
                    </label>

                    <div className="relative">
                      <select
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                        className="w-full border border-[#D0D5DD] rounded-lg px-4 py-3 text-[#667185] text-[14px] appearance-none bg-white focus:outline-none focus:ring-2 focus:ring-[#00AED9]"
                      >
                        <option value="" disabled>
                          Select reason
                        </option>

                        <option
                          className="text-[#898989] text-[14px] leading-[21px] font-normal"
                          value="Missing/inconsistent company name - unclear ownership."
                        >
                          Missing/inconsistent company name - unclear
                          ownership.
                        </option>
                        <option value="Incorrect industry/facility category.">
                          Incorrect industry/facility category.
                        </option>
                        <option value="Missing facility capacity.">
                          Missing facility capacity.
                        </option>
                        <option value="Vague facility/project description - unclear technology or activity.">
                          Vague facility/project description - unclear
                          technology or activity.
                        </option>
                        <option value="Missing or inaccurate facility/project location.">
                          Missing or inaccurate facility/project location.
                        </option>
                        <option value="Unspecified facility/project fuel source.">
                          Unspecified facility/project fuel source.
                        </option>
                        <option value="Unjustified or incorrect baseline scenario.">
                          Unjustified or incorrect baseline scenario.
                        </option>
                        <option value="Wrong or missing fuel source in baseline scenario.">
                          Wrong or missing fuel source in baseline scenario.
                        </option>
                        <option value="Missing/untraceable supporting documents.">
                          Missing/untraceable supporting documents.
                        </option>
                        <option value="Double counting & ghg participation..">
                          Double counting & ghg participation.
                        </option>
                      </select>

                      <svg
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M7 10l5 5 5-5"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>

                  <div className="flex flex-col gap-3 mb-8">
                    <label className="text-[#101828] font-semibold text-[16px]">
                      Additional Information
                    </label>
                    <textarea
                      value={additionalComment}
                      onChange={(e) => setAdditionalComment(e.target.value)}
                      placeholder="Enter additional details here..."
                      className="w-full h-[120px] border border-[#D0D5DD] rounded-lg p-4 text-[#667185] text-[14px] resize-none focus:outline-none focus:ring-2 focus:ring-[#00AED9]"
                    />
                  </div>

                  <button className="mt-auto w-full py-4 bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white rounded-2xl font-semibold text-[16px] hover:opacity-90 transition">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}

        {modalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center mx-auto  justify-center z-50"
            onClick={handleModalClose}
          >
            <div
              className="bg-white rounded-xl  p-8 w-[579px] max-w-[90%] h-[329px] relative text-center"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                aria-label="Close modal"
                onClick={() => setModalOpen(false)}
                className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white flex items-center justify-center"
              >
                <svg
                  width="20.730209350585938"
                  height="21.071121215820312"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    position: "relative",
                    top: "1.48px",
                    left: "1.47px",
                    opacity: 1,
                  }}
                  aria-hidden="true"
                  focusable="false"
                >
                  <circle
                    cx="11.5"
                    cy="11.5"
                    r="10"
                    fill="#FFFFFF"
                    stroke="#D0D5DD"
                    strokeWidth="1"
                  />
                  <path
                    d="M7.5 7.5L15.5 15.5M15.5 7.5L7.5 15.5"
                    stroke="#667085"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              <h2 className="text-[#101828] mt-24 font-semibold font-[600px] text-[24px] mb-4">
                Confirm KYC Validation
              </h2>

              <p className="text-[#667185]  text-[16px] font-[400px] mb-8">
                Are you sure you want to validate this user's KYC details?
                <br />
                Once validated, it can not be changed.
              </p>

              <div className="flex justify-center gap-8 ">
                <button
                  className="w-[209px] h-[70px]  border border-[#D0D5DD] rounded-2xl text-[#344054] text-[16px] font-medium"
                  onClick={() => setModalOpen(false)}
                >
                  Cancel
                </button>

                <button
                  onClick={() => handleValidate(selectedKyc)}
                  disabled={loading}
                  className="w-[209px] h-[70px] rounded-2xl bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white text-[16px] font-medium  disabled:opacity-50"
                >
                  {loading ? "Loading..." : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UploadValidation;